import React, { FC } from 'react';
import { Spinner } from 'react-bootstrap'
import { createPortal } from 'react-dom';

interface ILoader {
    isLoading: boolean;
    appendTo?: "body";
}

/**
 * Loader component for showing progress
 * @date 8/28/2023 - 11:23:57 AM
 *
 * @param {{ isLoading: any; appendTo?: "body"; }} {
    isLoading
    appendTo
}
 * @returns {*}
 */

const Loader: FC<ILoader> = ({
    isLoading,
    appendTo
}) => {
    if (!isLoading) return null;
    const loaderContent = (
        <div
            className={`theme-loader-z-index align-items-center bg-black bg-opacity-50 d-flex h-100 justify-content-center position-fixed start-0 top-0 w-100 ${isLoading === true ? 'd-block' : 'd-none'}`}>
            <Spinner animation="border" variant="light" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
    )
    // If appendTo is "body", render using portal to document.body
    if (appendTo === "body") {
        return createPortal(loaderContent, document.body);
    }

    // Otherwise, render normally in the component tree
    return loaderContent;
}

export default Loader;